module.exports = __webpack_public_path__ + "img/北京办公室2.3a6f6695.jpg";